import { SectionHeader } from '@sitoo/mui-components'
import { useTranslation } from 'react-i18next'
import { ApiKeyCredentials } from '../../../generated/graphql'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { CodeBlock } from '../../../components/code-block'

type Props = {
  open: boolean
  onClose: () => void
  credentials?: ApiKeyCredentials
}
export const ConnectionInformationDialog = (props: Props) => {
  const { credentials, open, onClose } = props
  const { t } = useTranslation(['api_keys', 'shared'])

  const { username, password, v2_base_url } = credentials || {}

  const loginVariables = [
    `API ID: ${username}`,
    `${t('api_keys:password')}: ${password}`,
    `${t('api_keys:base_url')}: ${v2_base_url}`,
  ].join('\n')

  const requestHeader = `Authorization: Basic ${btoa(username + ':' + password)}`

  const getCurl = [
    `curl -i \\`,
    `-X GET \\`,
    `-H "Content-Type: application/json" \\`,
    `-u "${username}:${password}" \\`,
    `-H "Accept: application/json" \\`,
    `-s "${v2_base_url}sites/1/productgroups.json"`,
  ].join('\n')

  const postCurl = [
    `curl -i \\`,
    `-X POST \\`,
    `-H "Content-Type: application/json" \\`,
    `-u "${username}:${password}" \\`,
    `-H "Accept: application/json" \\`,
    `-d '{"value":25,"productgrouptype":20,"productgroupname":"Shoes"}' \\`,
    `-s "${v2_base_url}sites/1/productgroups.json"`,
  ].join('\n')

  const curl = `${getCurl}\n\n${postCurl}`

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          mb: 2,
        }}
      >
        {t('api_keys:api_connection_information_title')}
      </DialogTitle>
      <DialogContent>
        <Alert
          variant="outlined"
          severity="error"
          sx={{
            mb: 3,
          }}
        >
          {t('api_keys:api_connection_information_banner')}
        </Alert>
        <Typography
          sx={{
            mb: 1,
          }}
        >
          {t('api_keys:api_connection_information_description')}
        </Typography>
        <SectionHeader
          variant="transparent"
          sx={{
            px: 0,
          }}
        >
          {t('api_keys:api_connection_information_login')}
        </SectionHeader>
        <CodeBlock code={loginVariables} />
        <SectionHeader
          variant="transparent"
          sx={{
            px: 0,
          }}
        >
          {t('api_keys:api_connection_information_request_header')}
        </SectionHeader>
        <CodeBlock code={requestHeader} />
        <SectionHeader
          variant="transparent"
          sx={{
            px: 0,
          }}
        >
          {t('api_keys:api_connection_information_curl')}
        </SectionHeader>
        <CodeBlock code={`${curl}`} />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose()
          }}
          color="secondary"
        >
          {t('shared:action.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
